import InvoiceServices from "@/services/billing/billing-invoice";
import EstimateServices from "@/services/billing/billing-estimate.js";
import { isEmpty, find } from "lodash";
const state = {
    invoiceDetails: [],
    estimateDetails: null,
    editDirty: false,
    availableClients: [],
    usersChooseInvoice: [],
    isSkipReEnableInvoice: false,
    invoiceIdLabProfile: null,
    invoiceIdLabProfileEdit: null
};
const getters = {
    invoiceDetails(state) {
        return state.invoiceDetails;
    },
    estimateDetails(state) {
        return state.estimateDetails;
    },
    isDirty(state) {
        return state.editDirty;
    },
    availableClients(state) {
        return state.availableClients;
    },
    usersChooseInvoice(state) {
        return state.usersChooseInvoice;
    },
    findUserChooseInvoice: state => invoiceId => {
        return invoiceId
            ? state.usersChooseInvoice.find(
                  user => user.invoiceId === invoiceId
              )
            : null;
    },
    /** For multiple invoices like payment modal, will return in array of object the list of invoices */
    findUserChooseInvoices: state => invoiceIds => {
        if (Array.isArray(invoiceIds) && invoiceIds.length > 0) {
            return invoiceIds
                .map(id =>
                    state.usersChooseInvoice.find(
                        invoice => invoice.invoiceId === id
                    )
                )
                .filter(Boolean);
        }
        return [];
    },
    /** Below code will no longer used as will using the component invoice-in-payment-warning
     * The existing component that use below code will slowly refactored to use above component
     */
    warningMessagePayment: (state, getters) => invoiceId => {
        const userChooseInvoice = getters.findUserChooseInvoice(invoiceId);
        if (userChooseInvoice) {
            return `${userChooseInvoice.userName} is currently creating a new payment for this invoice. Please wait until the transaction is completed to allow for a recalculation of the balance to avoid conflicts with reconciliation. This page will be refreshed once the payment is completed.`;
        }
        return "";
    },
    isSkipReEnableInvoice(state) {
        return state.isSkipReEnableInvoice;
    },
    invoiceIdLabProfile(state) {
        return state.invoiceIdLabProfile;
    },
    invoiceIdLabProfileEdit(state) {
        return state.invoiceIdLabProfileEdit;
    }
};
const mutations = {
    setInvoiceDetails(state, payload) {
        state.invoiceDetails = payload;
    },
    setEstimateDetails(state, payload) {
        state.estimateDetails = payload;
    },
    setDirty(state, payload) {
        state.editDirty = payload;
    },
    setAvailableClients(state, payload) {
        state.availableClients = payload;
    },
    setUsersChooseInvoice(state, payload) {
        state.usersChooseInvoice = payload;
    },
    setIsSkipReEnableInvoice(state, payload) {
        state.isSkipReEnableInvoice = payload;
    },
    setInvoiceIdLabProfile(state, payload) {
        state.invoiceIdLabProfile = payload;
    },
    setInvoiceIdLabProfileEdit(state, payload) {
        state.invoiceIdLabProfileEdit = payload;
    }
};
const actions = {
    async getInvoiceDetails({ commit }, payload) {
        const invoice = await InvoiceServices.getInvoice(
            payload.invoiceId,
            true,
            payload.index
        );
        commit("setInvoiceDetails", invoice.resource);
        return invoice;
    },
    async getEstimateDetails({ commit }, payload) {
        const estimate = await EstimateServices.getEstimate(
            payload.estimateId,
            true,
            payload.index
        );

        if (estimate && estimate.resource) {
            estimate.resource.hide_apply_disc = estimate.hide_apply_disc;
            estimate.resource.hide_remove_disc = estimate.hide_remove_disc;
            commit("setEstimateDetails", estimate.resource);
        }

        return estimate;
    },
    /**
     * userInvoice must be an object with, userId, userName and invoiceId
     *  */

    updateUsersChooseInvoice({ state }, payload) {
        if (!isEmpty(payload)) {
            if (payload.invoiceIds.length > 0) {
                payload.invoiceIds.forEach(invoiceId => {
                    let alreadyInObj = find(state.usersChooseInvoice, {
                        userId: payload.userId,
                        invoiceId: invoiceId
                    });

                    if (!alreadyInObj) {
                        state.usersChooseInvoice.push({
                            userId: payload.userId,
                            userName: payload.userName,
                            invoiceId: invoiceId,
                            paymentModalId: payload.paymentModalId
                        });
                    }
                });

                /**
                 * Invoice been remove, then the invoice id not in the payload.invoiceIds
                 * Check
                 *  - the item that not same user
                 *  - the item that not same payment moda id
                 *  - if user and payment modal id same, then remove the item with invoice id not in the payload
                 *  */
                state.usersChooseInvoice = state.usersChooseInvoice.filter(
                    item =>
                        payload.paymentModalId !== item.paymentModalId ||
                        (payload.paymentModalId === item.paymentModalId &&
                            payload.invoiceIds.includes(item.invoiceId))
                );
            } else {
                /**
                 * Empty invoice Id means user unselect all invoices
                 * Check based on payment
                 *  - the item that not same user
                 *  - the item that not same payment moda id
                 *  */
                state.usersChooseInvoice = state.usersChooseInvoice.filter(
                    item => payload.paymentModalId !== item.paymentModalId
                );
            }
        }
    },
    clearEstimateDetails({ commit }) {
        commit("setEstimateDetails", null);
    },
    clearInvoiceDetails({ commit }) {
        commit("setInvoiceDetails", null);
    }
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};
